@if (!item()!.hidden) {
  <ng-container *aclFeatures="item().section">

    <li data-username="able-pro dashboard dashboard"
        class="nav-item coded-hasmenu"
        [routerLinkActive]="['active']"
        [ngClass]="item().groupClasses">
      <a [routerLinkActive]="['active']"
         class="nav-link arrow-edge"
         (mouseenter)="navCollapse($event)">
        @if (item().icon) {
          @if (item().icontype === 'fa') {
            <i class="fa-micon {{item().icon}}"></i>
          } @else{
            <span class="coded-micon">
              <svg class="pc-icon">
                <use attr.xlink:href="assets/fonts/custom-icon.svg{{ item().icon }}"></use>
              </svg>
            </span>
          }
        }
        <span class="coded-mtext">{{ item().title | translate }}</span>
      </a>
      <ul class="coded-submenu"
          [routerLinkActive]="['active']"
          [ngClass]="item().classes!">
        @for (item of item().children; track item) {
          @if (item.type === 'item') {
            <app-menu-item [item]="item"></app-menu-item>
          } @else if (item.type === 'collapse') {
            <app-menu-collapse [item]="item"></app-menu-collapse>
          }
        }
      </ul>
    </li>
  </ng-container>
}